import { UseQueryResult, useQuery } from 'react-query'
import { request } from '../request'
import { UserUpload } from '../../lib/types/UserUpload'

export const useGetUploads = ({
  pageIndex,
  pageSize,
  filters,
}: {
  pageIndex?: number
  pageSize?: number
  filters?: Record<string, unknown>
}): UseQueryResult<DataWithPagination<UserUpload[]>, Error> => {
  return useQuery(['uploads', 'list', { pageIndex, pageSize }], () =>
    request({
      url: '/uploads',
      method: 'GET',
      params: {
        pageIndex,
        pageSize,
      },
    }),
  )
}
